// extracted by mini-css-extract-plugin
export default {"tag":"tag_tag__vufUP","clickable":"tag_clickable__O+1q-","disabled":"tag_disabled__dsrGs"};